/* eslint-disable react/display-name */
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@material-ui/core';
import { createStyles, makeStyles } from '@material-ui/styles';

import { formatTimeStamp } from '../../util';
import { BulkMessageEmailTypes, BulkMessageEmailTypesEnum, MessageTypes, ScheduledMessage } from './types';

interface BulkMessageScheduleTableProps {
  scheduledMessages: ScheduledMessage[];
}

const useStyles = makeStyles(() =>
  createStyles({
    tableContainer: {
      height: '600px',
      overflow: 'scroll',
    },
    content: {
      maxWidth: '500px',
      maxHeight: '100px',
      overflowY: 'scroll',
    },
  }),
);

export const BulkMessageScheduleTable: React.FC<BulkMessageScheduleTableProps> = ({ scheduledMessages }) => {
  const classes = useStyles();
  const { t } = useTranslation();

  const columns = [
    {
      field: 'status',
      headerName: t('bulkMessaging.columnHeading.status'),
    },
    {
      field: 'type',
      headerName: t('bulkMessaging.columnHeading.type'),
    },
    {
      field: 'scheduledAt',
      headerName: t('bulkMessaging.columnHeading.scheduledAt'),
    },
    {
      field: 'reservationStatus',
      headerName: t('bulkMessaging.columnHeading.reservationStatus'),
    },
    {
      field: 'reservationIds',
      headerName: t('bulkMessaging.columnHeading.reservationIds'),
    },
    {
      field: 'content',
      headerName: t('bulkMessaging.columnHeading.content'),
    },
  ];

  return (
    <div className={classes.tableContainer}>
      <TableContainer>
        <Table aria-labelledby="bulk-messaging" size={'medium'}>
          <TableHead>
            <TableRow>
              {columns.map(column => (
                <TableCell key={column.field} align="left">
                  {column.headerName}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {scheduledMessages.map((scheduledMessage, index) => {
              return (
                <TableRow hover tabIndex={-1} key={scheduledMessage.id}>
                  <TableCell key={`messageType-${index}`} align="left">
                    {scheduledMessage.isCompleted ? t('bulkMessaging.success') : t('bulkMessaging.pending')}
                  </TableCell>
                  <TableCell key={`messageType-${index}`} align="left">
                    {scheduledMessage.type?.toUpperCase()}
                  </TableCell>
                  <TableCell key={`scheduled-${index}`} align="left">
                    {scheduledMessage.scheduledAt ? formatTimeStamp(scheduledMessage.scheduledAt) : ''}
                  </TableCell>
                  <TableCell key={`reservationStatus-${index}`} align="left">
                    {!scheduledMessage.reservationIds?.length ? scheduledMessage.reservationStatus : ''}
                  </TableCell>
                  <TableCell key={`reservationIds-${index}`} align="left">
                    {scheduledMessage.reservationIds?.join(', ')}
                  </TableCell>
                  <TableCell key={`content-${index}`} align="left">
                    {scheduledMessage.emailType === BulkMessageEmailTypesEnum.individualEmail ? (
                      <div
                        className={classes.content}
                        dangerouslySetInnerHTML={{ 
                          __html: scheduledMessage.type === MessageTypes.SMS
                            ? scheduledMessage.content.en.replace(/\n/g, "<br />")
                            : scheduledMessage.content.en
                        }}
                      />
                    ) : (
                      <div className={classes.content}>{BulkMessageEmailTypes[scheduledMessage.emailType]}</div>
                    )}
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
};
